import "./printer-preference-success-message.scss";

const $getSuccessMessage = () =>
  document.querySelector(".js-jiffytransfers-landing-v2-printer-preference-success");

const $successMessage = $getSuccessMessage();

if ($successMessage) {
  const urlParams = new URLSearchParams(window.location.search);
  const preferenceSaved = urlParams.get("preference_saved");

  if (preferenceSaved === "true") {
    $successMessage.classList.remove("hidden");

    setTimeout(() => {
      $successMessage.scrollIntoView({
        behavior: "smooth",
        block: "center"
      });
    }, 100);

    // Remove preference_saved parameter from URL without reloading the page
    // Reset browser history so this page becomes effectively the first entry
    urlParams.delete("preference_saved");
    const { pathname, hash } = window.location;
    const queryString = urlParams.toString();
    const newUrl = `${pathname}${queryString ? `?${queryString}` : ""}${hash}`;

    // Replace current history entry to remove parameter
    // This replaces the entry with parameter, making current page the entry
    // Back button will go to the page before this one (not the parameterized version)
    window.history.replaceState({}, "", newUrl);
  } else {
    $successMessage.classList.add("hidden");
  }
}
